import { gql } from "apollo-boost"

export const getAll = gql`
  query getAccounts{
    Accounts {
      id
      uid
      email
      auditoryears
      roles {
        role
        regions
      }
      displayName
      disabled
      implementer{
        id
      }
    }
  }
`
